import axios from 'axios';
import AesEncryption from "../authentication/AesEncryption";
import Authentication from "./services/Authentication";
// Temporary debug control: set REACT_APP_API_DEBUG=true in your environment OR
// set localStorage key 'DRDATA_API_DEBUG' to 'true' in the browser to enable request/response logging.
// NOTE: This is a temporary development aid — remove or disable in production builds.
const debug = (typeof window !== 'undefined' && window.localStorage?.getItem('DRDATA_API_DEBUG') === 'true') || process.env.REACT_APP_API_DEBUG === 'true' || false;
var API = {
    async process(url, method, req) {
        //const baseURL = 'https://localhost:44458/';
        const baseURL = '';
        if (debug) {
            try {
                // Log the outgoing request data (un-encrypted) for debugging.
                console.debug('[API] Request:', { method, url, payload: req });
            } catch (e) {
                console.debug('[API] Request: (unserializable payload)', { method, url });
            }
        }
        var _req = (req) ? AesEncryption.encrypt(JSON.stringify(req)) : null;
        // token
        const token = Authentication.token;
        let customHeaders = {
            "Content-Type": "application/encrypted",
            "Accept": "application/encrypted",
        }
        if (await token() != null) {
            customHeaders = {
                "Content-Type": "application/encrypted",
                "Accept": "application/encrypted",
                "Authorization": "Bearer " + await token(),
                "Token": await Authentication.refresh(),
                "ShareID": Authentication.getShareID() ? Authentication.getShareID() : undefined,
                "Accessibility": AesEncryption.encrypt(Authentication.getFacility() + "|" + Authentication.getFacilityRole() + "|" + Authentication.getActivePatient())
            }
        }

        const requestConfig = {
            method: method,
            url: baseURL + url,
            headers: customHeaders,
        }
        requestConfig.data = _req ? _req : null
        try {
            const response = await axios(requestConfig)
            if (response.headers.get("Sync"))
                return response.headers.get("Sync")
            if (response.headers.get("Token")) {
                let rtoken = response.headers.get("Token")
                Authentication.refreshToken(rtoken)
            }
            if (debug) {
                // Log encrypted response briefly (avoid leaking secrets) and decrypted body
                try {
                    console.debug('[API] Raw response headers:', Array.from(response.headers.entries()));
                } catch (e) {
                    console.debug('[API] Raw response headers: (unserializable headers)');
                }
            }
            if (response.status === 204) // No Content
                return true
            const decrypted = AesEncryption.decrypt(response.data, debug)
            if (debug) console.debug('[API] Decrypted response:', decrypted)
            return decrypted
        } catch (err) {
            if (axios.isAxiosError(err)) {
                if (err.response?.status === 401) {
                    if (
                        window.location.href.indexOf('/logout') === -1 &&
                        window.location.href.indexOf('/expired') === -1
                    ) {
                        window.location.assign('/expired')
                    }
                }
                else {
                    const _err = err
                    throw AesEncryption.decrypt(_err.response.data, url, debug)
                }
            } else throw err
        }
    }
}

export default API;